import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch, FaList, FaTable, FaChevronDown, FaChevronRight } from 'react-icons/fa';
import NavItem from '../../components/NavItem';
import IconButton from '../../components/IconButton';
import api from '../../services/api';
import { pontoVirgula } from '../../util/util';
import ReactSelect from '../../components/ReactSelect';
import { Card } from 'react-bootstrap';
import { gruposAchadosNaBusca, incluirItensDosGruposAchados } from './buscaItensOrcamentariosPolicy';

export default function PainelProduto() {
    const perfilRaw = localStorage.getItem("perfil") || "";
    const perfis = perfilRaw
        .toLowerCase()
        .split(',')
        .map(p => p.trim())
        .filter(Boolean);
    const isSomenteConsulta = perfis.includes('evento') || perfis.includes('gerenteevento') || perfis.includes('gerenteeventointernacional');
    const podeEditar = ['admin', 'diretor', 'gerenteprojeto'].some(p => perfis.includes(p)) && !isSomenteConsulta;
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState({});
    const [produtos, setProdutos] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [gruposAbertos, setGruposAbertos] = useState([]);

    const buscar = () => {
        setFiltro(prev => ({ ...prev, buscando: true }));

        var filtroBuscar = {
            ...filtro,
            // Decisão do Rafael (18/09): ocultar inativo, nunca apagar do catálogo —
            // produtos inativos continuam vinculados a orçamentos históricos.
            ...{ modulo: 'servicoOrcamento', situacaoRegistro: 'ativo' }
        }

        if (filtroBuscar.cliente) {
            filtroBuscar.cliente = filtroBuscar.cliente.map(cliente => cliente.value).join(',');
        }

        api({
            method: 'get',
            action: '/produto',
            token: token,
            params: filtroBuscar
        })
            .then(async response => {
                let todosItens = response.data.data;
                // Turma 5 (20/10): busca pelo nome do GRUPO ("Serviços agência") traz os itens dele e já abre o grupo.
                const gruposAchados = filtroBuscar.nome ? gruposAchadosNaBusca(todosItens) : [];
                if (gruposAchados.length > 0) {
                    const semNome = { ...filtroBuscar };
                    delete semNome.nome;
                    const completa = await api({ method: 'get', action: '/produto', token: token, params: semNome });
                    todosItens = incluirItensDosGruposAchados(todosItens, completa.data.data);
                    // ids no mesmo tipo do item.superior.id (o includes da tela compara sem converter)
                    const abrir = todosItens.filter(p => !p.superior).map(p => p.id);
                    setGruposAbertos(prev => Array.from(new Set([...prev, ...abrir])));
                }
                console.log('Itens carregados:', todosItens.length);
                setProdutos(todosItens);
                
                // Agrupa itens por grupo superior
                const gruposMap = {};
                const itensSemGrupo = [];
                
                todosItens.forEach(item => {
                    if (item.superior) {
                        const grupoId = item.superior.id;
                        if (!gruposMap[grupoId]) {
                            gruposMap[grupoId] = {
                                id: grupoId,
                                codigo: item.superior.codigo,
                                nome: item.superior.nome,
                                itens: []
                            };
                        }
                        gruposMap[grupoId].itens.push(item);
                    } else {
                        // Itens que são grupos (não têm superior)
                        itensSemGrupo.push(item);
                    }
                });
                
                // Converte o map em array e ordena por código
                const gruposArray = Object.values(gruposMap).sort((a, b) => {
                    const codigoA = parseInt(a.codigo) || 0;
                    const codigoB = parseInt(b.codigo) || 0;
                    return codigoA - codigoB;
                });
                
                console.log('Grupos criados:', gruposArray.length);
                setGrupos(gruposArray);
                setFiltro(prev => ({ ...prev, buscando: false }));
            }).catch(err => {
                console.error('Erro ao buscar produtos:', err);
                setFiltro(prev => ({ ...prev, buscando: false }));
            })
    };

    const toggleGrupo = (grupoId) => {
        setGruposAbertos(prev => {
            if (prev.includes(grupoId)) {
                return prev.filter(id => id !== grupoId);
            } else {
                return [...prev, grupoId];
            }
        });
    };

    const expandirTodos = () => {
        setGruposAbertos(grupos.map(g => g.id));
    };

    const recolherTodos = () => {
        setGruposAbertos([]);
    };
    
    useEffect(() => { //onload
        document.querySelector("#nome")?.focus(); //autofocus no nome
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    {podeEditar ?
                        <NavItem to="/cadastroServicoOrcamento" icon={<FaPlus size={20} />} color="primary">Novo Item Orçamentário</NavItem> :
                        null}
                    {!isSomenteConsulta && (
                        <>
                            <NavItem to="/produtoGrupo" icon={<FaList size={20} />} color="outline-dark">Grupos de Atributos</NavItem>
                            <NavItem to="/produtoTipoAtributo" icon={<FaList size={20} />} color="outline-dark">Tipo Atributos</NavItem>
                            <NavItem to="/produtoAtributo" icon={<FaList size={20} />} color="outline-dark">Atributos</NavItem>
                        </>
                    )}
                    <NavItem to="/servicoOrcamentoRelatorio" icon={<FaTable size={20} />} color="outline-dark">Relatório de Itens</NavItem>
                </ul>
                <div className="page-title">
                    <h3>Itens Orçamentários</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Cliente</label>
                                                        <ReactSelect
                                                            id="cliente"
                                                            isMulti={true}
                                                            value={filtro.cliente || []}
                                                            onChange={(e) => {
                                                                filtro.cliente = filtro.cliente || [];
                                                                filtro.cliente = e;
                                                                setFiltro({ ...filtro });
                                                            }}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/participante',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                        tipoCadastro: "cliente",
                                                                        situacaoRegistro: "ativo",
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map((registro) => {
                                                                            var label = registro.codigo +
                                                                                ' - ' + registro.nome +
                                                                                (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                                                (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                                                (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                                                (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                                            return {
                                                                                value: registro.id,
                                                                                label: label
                                                                            };
                                                                        });
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="nome" placeholder="Buscar pelo nome do serviço"
                                                            onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Nome</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSearch size={20} /> Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row mb-4">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    {filtro.buscando ? (
                                        <div className="text-center py-4">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Buscando...</span>
                                            </div>
                                            <p className="mt-2">Buscando...</p>
                                        </div>
                                    ) : grupos.length === 0 ? (
                                        <div className="text-center py-4">
                                            <p>Nenhum registro encontrado</p>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5 className="mb-0">{grupos.length} {grupos.length === 1 ? 'Grupo' : 'Grupos'} encontrado{grupos.length === 1 ? '' : 's'}</h5>
                                                <div>
                                                    <button 
                                                        className="btn btn-sm btn-outline-primary me-2" 
                                                        onClick={expandirTodos}
                                                        disabled={gruposAbertos.length === grupos.length}
                                                    >
                                                        Expandir Todos
                                                    </button>
                                                    <button 
                                                        className="btn btn-sm btn-outline-secondary" 
                                                        onClick={recolherTodos}
                                                        disabled={gruposAbertos.length === 0}
                                                    >
                                                        Recolher Todos
                                                    </button>
                                                </div>
                                            </div>
                                            
                                            <div>
                                                {grupos.map((grupo, indexGrupo) => (
                                                    <Card key={grupo.id} className="mb-2">
                                                        <Card.Header 
                                                            style={{ 
                                                                backgroundColor: '#f8f9fa',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.2s',
                                                                padding: '20px 15px',
                                                                minHeight: '65px'
                                                            }}
                                                            onClick={() => toggleGrupo(grupo.id)}
                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                                        >
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <div className="d-flex align-items-center">
                                                                    {gruposAbertos.includes(grupo.id) ? (
                                                                        <FaChevronDown className="me-2" />
                                                                    ) : (
                                                                        <FaChevronRight className="me-2" />
                                                                    )}
                                                                    <strong style={{ fontSize: '16px' }}>
                                                                        {grupo.codigo} - {grupo.nome}
                                                                    </strong>
                                                                </div>
                                                                <span className="badge bg-primary rounded-pill">
                                                                    {grupo.itens.length} {grupo.itens.length === 1 ? 'item' : 'itens'}
                                                                </span>
                                                            </div>
                                                        </Card.Header>
                                                        {gruposAbertos.includes(grupo.id) && (
                                                            <Card.Body className="p-0">
                                                                <div className="table-responsive">
                                                                    <table className="table table-hover mb-0">
                                                                        <thead className="table-light">
                                                                            <tr>
                                                                                {podeEditar && <th style={{ width: '100px' }}>Ações</th>}
                                                                                <th style={{ width: '80px' }}>Situação</th>
                                                                                <th style={{ width: '80px' }}>Código</th>
                                                                                <th style={{ width: '120px' }}>Cód. Fornec.</th>
                                                                                <th>Nome</th>
                                                                                <th style={{ width: '200px' }}>Cliente</th>
                                                                                <th style={{ width: '120px' }}>Preço/Fee</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {grupo.itens.map((item, indexItem) => (
                                                                                <tr key={item.id}>
                                                                                    {podeEditar && (
                                                                                        <td>
                                                                                            <IconButton
                                                                                                small={true}
                                                                                                to={"/cadastroServicoOrcamento/" + item.id}
                                                                                                icon={<FaPen size={16} />}
                                                                                                color="primary"
                                                                                            >
                                                                                                Editar
                                                                                            </IconButton>
                                                                                        </td>
                                                                                    )}
                                                                                    <td>
                                                                                        <span className={`badge ${item.situacaoRegistro === 'ativo' ? 'bg-success' : 'bg-secondary'}`}>
                                                                                            {item.situacaoRegistro || '-'}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td className="text-end">{item.codigo || '-'}</td>
                                                                                    <td>{item.codigoFornecedor || '-'}</td>
                                                                                    <td>
                                                                                        <strong>{item.nome}</strong>
                                                                                    </td>
                                                                                    <td>
                                                                                        {item.cliente && Array.isArray(item.cliente) ? (
                                                                                            <div style={{ fontSize: '12px' }}>
                                                                                                {item.cliente.slice(0, 2).map((cliente, idx) => (
                                                                                                    <div key={idx}>
                                                                                                        {cliente.codigo} - {cliente.nome}
                                                                                                        {cliente.enderecomunicipio && ` - ${cliente.enderecomunicipio.nome}-${cliente.enderecomunicipio.uf}`}
                                                                                                    </div>
                                                                                                ))}
                                                                                                {item.cliente.length > 2 && <div>...</div>}
                                                                                            </div>
                                                                                        ) : '-'}
                                                                                    </td>
                                                                                    <td>
                                                                                        <span className={`badge ${item.tipoPreco === 'percentual' ? 'bg-info' : 'bg-success'}`}>
                                                                                            {item.tipoPreco === 'percentual' ? '% ' : 'R$ '}
                                                                                            {pontoVirgula(item.preco)}
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </Card.Body>
                                                        )}
                                                    </Card>
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
